var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordingIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.093V2.907C0 2.1078 0.285 1.4238 0.855 0.855C1.425 0.2862 2.109 0.0012 2.907 0H15.093C15.8922 0 16.5762 0.285 17.145 0.855C17.7138 1.425 17.9988 2.109 18 2.907V15.093C18 15.8922 17.715 16.5762 17.145 17.145C16.575 17.7138 15.891 17.9988 15.093 18H2.907C2.1078 18 1.4238 17.715 0.855 17.145C0.2862 16.575 0.0012 15.8898 0 15.093Z",
    fill: "#DE2D2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingIndicator);
export default __webpack_public_path__ + "static/media/recording-indicator.514cdf10bc9de919318bb3d975ce26cc.svg";
export { ForwardRef as ReactComponent };